import { createStyles } from '@mantine/core';
import React from 'react';

import { useAnalyticsStats } from '@portals/api/partners';

import { StatsWidget } from './StatsWidget';

export function StatsWidgets() {
  const { classes } = useStyles();

  const analyticsStats = useAnalyticsStats();

  return (
    <div className={classes.container}>
      <StatsWidget
        label="Registered Customers"
        count={analyticsStats.data?.organizations?.length}
      />

      <StatsWidget label="Users" count={analyticsStats.data?.users} />

      <StatsWidget
        label="Claimed devices"
        count={analyticsStats.data?.claimed_devices}
      />
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing.lg,
  },
}));
